import { render, staticRenderFns } from "./TYKSStart.vue?vue&type=template&id=7ea025f6&scoped=true"
import script from "./TYKSStart.vue?vue&type=script&lang=js"
export * from "./TYKSStart.vue?vue&type=script&lang=js"
import style0 from "./TYKSStart.vue?vue&type=style&index=0&id=7ea025f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea025f6",
  null
  
)

export default component.exports